import type { FormProps } from "antd";
import type { ReactNode } from "react";
import { isValidElement } from "react";
import {
  FormLabelInlineHint,
  mergeRequiredIntoLabelNode,
} from "./formLabelWithInlineHint";

export const separationFormRequiredMark: Exclude<
  FormProps["requiredMark"],
  boolean | "optional" | undefined
> = (labelNode, { required }): ReactNode => {
  if (isValidElement(labelNode) && labelNode.type === FormLabelInlineHint) {
    return mergeRequiredIntoLabelNode(labelNode, required);
  }

  return (
    <>
      {labelNode}
      {required ? (
        <span
          className="text-[var(--color-error)] ml-1 font-sans leading-none shrink-0"
          aria-hidden="true"
        >
          *
        </span>
      ) : null}
    </>
  );
};
